import styled from 'styled-components';

import { AppVideo } from 'appLanding/components/AppVideo';
import { MOBILE_PROMO_IMG } from 'appLanding/enums/appLandingPageEnums';
import { KeyFeatures } from 'appLanding/components/KeyFeatures';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';

const MobilePromoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    display: none;
  }
`;

const MobilePromoImage = styled.img`
  min-width: calc(100vw - 32px);
  width: calc(100vw - 32px);
  max-width: calc(100vw - 32px);
  margin-top: 16px;
`;

const AppLandingPage = () => (
  <>
    <AppVideo />
    <MobilePromoSection>
      <MobilePromoImage data-qa="app_video_mobile_promo_image" src={MOBILE_PROMO_IMG} alt="" />
    </MobilePromoSection>
    <KeyFeatures />
  </>
);

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await setServerSideTranslations({ locale })),
    },
  };
};

export default AppLandingPage;
